<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b> 通知公告 共{{ total }}条</b>
            <div class="flex align-center">
                <router-link class="page-back margin-right-xs" to="/organization/notice/apply">审核列表
                </router-link>
                <router-link class="add-btn" to="/organization/notice/edit/0">发布通知
                </router-link>
            </div>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm list-search">
            <el-input
                v-model="keyWord"
                placeholder="请输入通知公告标题关键字"
            ></el-input>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        </div>
        <el-skeleton v-if="loading" :rows="10"/>
        <empty v-if="noData" :type="4"/>
        <div class="list-box">
            <div
                v-for="item in list"
                :key="item.id"
                class="item-box margin-bottom-sm"
            >
                <h3 class="ovHide">{{ item.title }}</h3>
                <div class="flex align-center justify-between item-info">
                    <div>
                        <p>
                            {{ item.add_time | timer }} <span class="padding-lr-xs"> </span
                        >{{ item.is_feedback === 1 ? "反馈通知" : "普通通知" }}
                        </p>
                        <p>
                            <span class="padding-right-xs">已读： <i>{{ item.read_num }}人</i> </span>
                            <span class="padding-right-xs">未读：<i>{{ item.not_read_num }}人</i> </span>
                            <span v-if="item.is_feedback === 1" class="padding-right-xs">已反馈： <i>{{
                                    item.feedback_num
                                }}人</i></span>
                            <span v-if="item.is_feedback === 1"
                                  class="padding-right-xs"> 未反馈：<i>{{ item.not_feedback_num }}人</i></span>
                        </p>
                    </div>
                    <div class="right-btn">
                        <router-link :to="'/organization/notice/detail/' + item.id">
                            <el-button class="have-color" round type="primary"
                            >{{ item.is_feedback === 1 ? '查看反馈' : '查看详情' }}
                            </el-button
                            >
                        </router-link>
                        <router-link
                            :to="'/organization/notice/edit/' + item.id"
                            class="margin-lr-xs"
                        >
                            <el-button class="have-color" round type="primary"
                            >编辑
                            </el-button
                            >
                        </router-link>

                        <el-button class="line-btn" round @click="delItem(item.id,item.feedback_num )">删除</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="list.length > 0" class="flex align-center justify-between">
            <span>共{{ total }}条数据</span>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                layout="prev, pager, next, jumper"
                @current-change="getList"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {zhDate} from '@//utils/utils'
import {noticeDel, noticeList} from "@/api/organiz";

export default {
    name: "index",
    data() {
        return {
            page: 1,
            limit: 10,
            total: 0,
            keyWord: '',
            list: [],
            noData: false,
            loading: true,
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.getList()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //    删除通知公告
        delItem(id, feedback_num) {
            this.$confirm(feedback_num ? `此通知有${feedback_num}条反馈信息，是否确定删除？` : `此操作将删除该通知公告, 是否继续?`, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(id)
            })
        },
        async sureDelete(id) {
            let _state = await noticeDel(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.getList()
        },
        search() {
            this.page = 1
            this.getList()
        },
        async getList() {
            this.list = []
            this.loading = true
            let _list = await noticeList(this.page, this.limit, this.keyWord)
            if (_list.status === 0) {
                this.list = []
                this.noData = true
                this.loading = false
            } else {
                this.loading = false, this.noData = false, this.list = _list.data, this.total = _list.count
            }
        }
    },
    filters: {
        timer(val) {
            return zhDate(val * 1000)
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
        }
    }

    .list-search {
        .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .item-box {
        border-radius: 10px;
        border: solid 1px #dae0e6;

        &:hover {
            background-color: #f3f7fb;
        }

        h3 {
            font-size: 18px;
            line-height: 34px;
            padding: 5px 20px;
            color: #333333;
            border-bottom: 1px solid #dae0e6;
        }

        .item-info {
            padding: 15px 20px;

            p {
                line-height: 24px;
                font-size: 14px;
                color: #999999;

                i {
                    color: #ffb400;
                }
            }
        }

        .right-btn {
            .have-color {
                background: #0a2240;
                border: 0;
            }
        }
    }
}
</style>